<template>
  <div class="dovemed-wrapper">
    <div v-if="allCircles">
      <div class="allcircles col-12 m-0 p-0">
        <!-- <div v-if="joinedCircle.length > 0">
          <div class=" mt-3">
            <div class="text-small--black">YOUR CIRCLES</div>
            <div class="title-text--black">Circles you're part of</div>
          </div>
          <div
            v-if="joinedCircle.length < 0"
            :style="{ 'text-align': 'center', 'font-weight': 'bold' }"
          >
            You are not part of any circles yet.
          </div>
          <div
            class="   mt-md-0  p-2 "
            v-for="(circle, index) in joinedCircle"
            :key="index"
          >
            <div class="allcircles-card joined-circle ">
              <div class="allcircles-card-left">
                <div class="allcircles-card-left--color">
                  <div
                    class="allcircles-card-left--top"
                    :style="{ 'margin-bottom': '0px' }"
                  >
                    <div
                      class="allcircles-card-left--color--img"
                      :style="`background-color:${circle.color_code}`"
                    ></div>

                    <div class="allcircles-card-left--name">
                      <div
                        v-if="circle.condition_type"
                        class="allcircles-card-left--name--type"
                      >
                        {{ circle.condition_type.slice(0, 100) }}
                        {{ circle.condition_type.length > 100 ? "..." : "" }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="allcircles-card-right"
                :style="{ padding: '0px 35px' }"
              >
                <a-button
                  @click="goToCircle(circle, $event)"
                  :loading="selectedCircle === circle.condition_type"
                  :id="circle.enter ? 'enter' : 'register'"
                  :style="{ color: '#ffffff' }"
                  :class="
                    `dovemed-button  ${
                      circle.enter
                        ? 'enter-button'
                        : 'primary-dark-background font-white'
                    } mx-auto uppercase`
                  "
                >
                  <span :style="{ color: '#ffffff' }">
                    {{ circle.enter ? "ENTER" : "JOIN" }}</span
                  >
                </a-button>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div v-if="otherCircle.length > 0" class=" mt-3">
          <div class="text-small--black">JOIN NOW</div>
          <div class="title-text--black">Browse our Circles</div>
        </div> -->
        <!-- <div
          class="   mt-md-0  p-2 "
          v-for="(circle, index) in otherCircle"
          :key="index"
        >
          <div class="allcircles-card">
            <div class="allcircles-card-left">
              <div class="allcircles-card-left--color">
                <div class="allcircles-card-left--top">
                  <div
                    class="allcircles-card-left--color--img"
                    :style="`background-color:${circle.color_code}`"
                  ></div>
                </div>
              </div>
              <div>
                <div class="allcircles-card-left--name">
                  <div
                    v-if="circle.condition_type"
                    class="allcircles-card-left--name--type"
                  >
                    {{ circle.condition_type.slice(0, 100) }}
                    {{ circle.condition_type.length > 100 ? "..." : "" }}
                  </div>
                  <div
                    v-if="circle.description"
                    :class="
                      circle.description
                        ? 'allcircles-card-left--name--description'
                        : 'allcircles-card-left--name--description invisible'
                    "
                  >
                    {{ circle.description.slice(0, 60) }}
                    {{ circle.description.length > 60 ? "..." : "" }}
                  </div>
                  <div
                    v-if="circle.long_description"
                    class="allcircles-card-left--name--ldescription"
                  >
                    {{ circle.long_description.slice(0, 250) }}
                    {{ circle.long_description.length > 250 ? "..." : "" }}
                  </div>
                </div>
              </div>
            </div>
            <div class="allcircles-card-right">
              <div class="allcircles-card-right--info">
                <div class="m-2 allcircles-card-right--info--box">
                  <div class="allcircles-card-right--info__number">
                    {{ circle.post_count }}
                  </div>
                  <div class="allcircles-card-right--info__text">Posts</div>
                </div>
                <div class="m-2 allcircles-card-right--info--box">
                  <div class="allcircles-card-right--info__number">
                    {{ circle.comment_count }}
                  </div>
                  <div class="allcircles-card-right--info__text">Replies</div>
                </div>

                <div class="m-2 allcircles-card-right--info--box">
                  <div class="allcircles-card-right--info__number">
                    {{ circle.user_count }}
                  </div>
                  <div class="allcircles-card-right--info__text">Members</div>
                </div>
              </div>
              <button
                @click="goToCircle(circle, $event)"
                :id="circle.enter ? 'enter' : 'register'"
                :class="
                  `dovemed-button  ${
                    circle.enter
                      ? 'enter-button'
                      : 'primary-dark-background font-white'
                  } mx-auto uppercase`
                "
              >
                {{ circle.enter ? "ENTER" : "JOIN" }}
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div
      v-if="isFetchingCircles"
      class="d-flex align-items-center flex-column justify-content-center mt-4"
    >
      <div>
        <div class="spinner-border spinner-class"></div>
      </div>
      <div>
        Loading circles...
      </div>
    </div> -->
    <!-- <div class="cant-find-condition dark-bg ">
      <p class="mb-4 mt-3 title">Can’t find your condition?</p>
      <p class="mb-4 sub-text">
        We are constantly adding new health conditions to the MyCircles
        platform. However, if you do not see a particular condition, please send
        us a message and we would love to consider your request.
      </p>
      <button
        @click="$router.push({ name: 'ContactUs' })"
        id="enter"
        class="dovemed-button primary-dark-background font-white mt-3 bold-text"
      >
        CONTACT US
      </button>
    </div>
    <div class="crisis-info">
      <div class="crisis-info-top ">
        <div class="d-flex align-items-center">
          <div
            class="circle-phone"
            :style="{ background: '#ffffff', 'margin-right': '16px' }"
          >
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="phone-volume"
              class="svg-inline--fa fa-phone-volume "
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="#062B54"
                d="M284.6 181.9c-10.28-8.344-25.41-6.875-33.75 3.406C242.4 195.6 243.9 210.7 254.2 219.1c11.31 9.25 17.81 22.69 17.81 36.87c0 14.19-6.5 27.62-17.81 36.87c-10.28 8.406-11.78 23.53-3.375 33.78c4.719 5.812 11.62 8.812 18.56 8.812c5.344 0 10.75-1.781 15.19-5.406c22.53-18.44 35.44-45.4 35.44-74.05S307.1 200.4 284.6 181.9zM345.1 107.1c-10.22-8.344-25.34-6.907-33.78 3.343c-8.406 10.25-6.906 25.37 3.344 33.78c33.88 27.78 53.31 68.18 53.31 110.9s-19.44 83.09-53.31 110.9c-10.25 8.406-11.75 23.53-3.344 33.78c4.75 5.781 11.62 8.781 18.56 8.781c5.375 0 10.75-1.781 15.22-5.438C390.2 367.1 416 313.1 416 255.1S390.2 144.9 345.1 107.1zM406.4 33.15c-10.22-8.344-25.34-6.875-33.78 3.344c-8.406 10.25-6.906 25.37 3.344 33.78C431.9 116.1 464 183.8 464 255.1s-32.09 139.9-88.06 185.7c-10.25 8.406-11.75 23.53-3.344 33.78c4.75 5.781 11.62 8.781 18.56 8.781c5.375 0 10.75-1.781 15.22-5.438C473.5 423.8 512 342.6 512 255.1S473.5 88.15 406.4 33.15zM151.3 174.6C161.1 175.6 172.1 169.5 176 159.6l33.75-84.38C214 64.35 209.1 51.1 200.2 45.86l-67.47-42.17C123.2-2.289 110.9-.8945 102.9 7.08C-34.32 144.3-34.31 367.7 102.9 504.9c7.982 7.984 20.22 9.379 29.75 3.402l67.48-42.19c9.775-6.104 13.9-18.47 9.598-29.3L176 352.5c-3.945-9.963-14.14-16.11-24.73-14.97l-53.24 5.314C78.89 286.7 78.89 225.4 98.06 169.3L151.3 174.6z"
              ></path>
            </svg>
          </div>
          Crisis Help Info
        </div>
      </div>
      <div class="crisis-info-mid">
        In case of an emergency or if you need immediate help, please visit our
        Crisis center.
      </div>
      <div class="crisis-info-bottom ">
        <div @click="goToCrisisPage" class="dovemed-button">Click Here</div>
      </div>
    </div> -->
    <div id="learn-more" class="learn-more-section">
      <div class="chooserole-wrapper">
        <div
          :style="{
            'font-size': '10px',
            'font-weight': '700',
            'text-align': 'center',
            'letter-spacing': '2px',
            'line-height': '12px',
            'margin-bottom': '8px',
            color: '#1E2945',
          }"
        >
          LEARN MORE ABOUT MYCIRCLES
        </div>
        <h2
          :style="{
            'font-size': '36px',
            'font-weight': '700',
            'text-align': 'center',
            'padding-bottom': '48px',
            'line-height': '46px',
          }"
        >
          Choose your role
        </h2>
      </div>
      <div class="d-flex choose-role">
        <div class="choose-role--box section-box selected" @click="() => handleSelectBox('0')">
          <div class="box-icon">
            <font-awesome-icon size="1x" class="hw20" :icon="['fal', 'user']" />
          </div>
          <div class="d-flex flex-column">
            <div class="choose-role--box__medium role-label">I'm a</div>
            <div class="choose-role--box__big role-label-md">Patient or Caregiver</div>
          </div>
        </div>
        <div class="choose-role--box section-box" @click="() => handleSelectBox('1')">
          <div class="box-icon">
            <font-awesome-icon size="1x" class="hw20" :icon="['fal', 'bullhorn']" />
          </div>
          <div class="d-flex flex-column">
            <div class="choose-role--box__medium role-label">I'm an</div>
            <div class="choose-role--box__big role-label-md">Advocate</div>
          </div>
        </div>
        <div class="choose-role--box section-box" @click="() => handleSelectBox('2')">
          <div class="box-icon">
            <font-awesome-icon size="1x" class="hw20" :icon="['fal', 'user-md']" />
          </div>
          <div class="d-flex flex-column">
            <div class="choose-role--box__medium role-label">I'm a Healthcare</div>
            <div class="choose-role--box__big role-label-md">Professional</div>
          </div>
        </div>
        <div class="choose-role--box section-box" @click="() => handleSelectBox('3')">
          <div class="box-icon hospital-icon">
            <!-- <font-awesome-icon
              size="1x"
              class = "hw20"
              :icon="['fal', 'hospital']"
            /> -->
            <img v-if="!isHOA" src="../../../assets/images/hospital-icon-blue.png" class="hw20 m-auto" alt="icon" />
            <img v-else src="../../../assets/images/hospital-icon-white.png" class="hw20 m-auto" alt="icon" />
          </div>
          <div class="d-flex flex-column">
            <div class="choose-role--box__medium role-label">I'm a Health Organization</div>
            <div class="choose-role--box__big role-label-md">Administrator</div>
          </div>
        </div>
        <div class="choose-role--box section-box" @click="() => handleSelectBox('4')">
          <div class="box-icon">
            <font-awesome-icon size="1x" class="hw25" :icon="['fal', 'handshake-alt']" />
          </div>
          <div class="d-flex flex-column">
            <div class="choose-role--box__medium role-label">I'm a</div>
            <div class="choose-role--box__big role-label-md">Partner or Sponsor</div>
          </div>
        </div>
      </div>
      <div>
        <div class="choose-box--description show-class">
          <patient-static></patient-static>
        </div>
        <div class="choose-box--description none-class">
          <advocate-static></advocate-static>
        </div>
        <!-- healthcare -->
        <div class="choose-box--description none-class">
          <healthcare-static></healthcare-static>
        </div>
        <!-- healthcare admin -->
        <div class="choose-box--description none-class">
          <health-care-admin></health-care-admin>
        </div>
        <!-- partner or sponsor -->
        <div class="choose-box--description none-class">
          <partner-static></partner-static>
        </div>
      </div>
    </div>

    <div class="getstarted">
      <div class="getstarted--left">
        <div class="getstarted--left__big">Get Started for Free!</div>
        <div class="getstarted--left__medium">
          Don't take our word for it. Join MyCircles today! Be part of a support community, connect with healthcare professionals, share your stories and experiences, and contribute in building a
          healthy society.
        </div>
      </div>
      <div @click="() => goToSSO()" class="getstarted--right">
        <!-- <div @click="getStartedButton" class="getstarted--right"> -->
        <div class="button">GET STARTED</div>
      </div>
    </div>

    <!-- <div class="text-center dovemed-wrapper">
      <h5 class=" title-text" :style="{ 'padding-top': '48px' }">
        What our members are saying
      </h5>
      <a-carousel autoplay>
        <div class="centered-div ">
          <i
            >This is a great place to meet others that are going through similar
            problems, get advice and help cope with the daily struggles.</i
          >
          <br />
          <i class="advertise-text-author-name">”Daniel T”</i>
          <i class="advertise-text-author-name">”MyCircles”</i>
        </div>
        <div class="centered-div">
          <i
            >The MyCircles is an excellent platform for people with chronic
            disorders to share their varied experiences, ask questions, and stay
            connected with others having the same disorder.</i
          >
          <br />
          <i class="advertise-text-author-name">”Joseph K”</i>
          <i class="advertise-text-author-name">”MyCircles”</i>
        </div>
      </a-carousel>
    </div> -->
    <AccVerifyModal ref="accVerify" />
    <!-- <SSOModal ref="modal" /> -->
  </div>
</template>

<script>
// import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import { eventBus } from "../../../main"
// import SSOLogin from "../../login/login-register-component.vue"
// import SSOModal from "../../login/login-register-modal.vue"
import PatientStatic from "./AllCircleStaticPages/patientStatic.vue"
import AdvocateStatic from "./AllCircleStaticPages/AdvocateStatic.vue"
import HealthcareStatic from "./AllCircleStaticPages/HealthCareProfessionalStatic.vue"
import AccVerifyModal from "../../Modals/AccountNotVerifiedWarning.vue"
import PartnerStatic from "./AllCircleStaticPages/PartnerStatic.vue"
import HealthCareAdmin from "./AllCircleStaticPages/HealthCareAdmin.vue"
import { faUser, faHandshakeAlt, faCheckCircle } from "@fortawesome/pro-light-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"

// const AppRepository = RepositoryFactory.get("app");
// const CircleRepository = RepositoryFactory.get("circle");
// const UserRepository = RepositoryFactory.get("user");
library.add(faUser, faHandshakeAlt, faCheckCircle)

/**
 * Circle Management
 * @displayName Circles
 */
export default {
  name: "AllCircles",

  components: {
    // SSOLogin,
    // SSOModal,
    PatientStatic,
    AdvocateStatic,
    HealthcareStatic,
    AccVerifyModal,
    PartnerStatic,
    HealthCareAdmin,
  },
  data() {
    return {
      allCircles: null,
      // myCircles: null,
      // joinedCircle: [],
      // otherCircle: [],
      // isFetchingCircles: false,
      // selectedCircle: false,
      // enteredCircles: [],
      // userAdminRoles: ["hospital_administrator", "clinic_administrator", "doctor", "nfp_administrator", "hcp"],
      isHOA: false,
    }
  },

  watch: {
    "$store.state.User.user": function() {
      // this.$router.go();
    },
    // allCircles: function() {
    //   this.joinedCircle = this.allCircles.filter(ele => ele.enter === true)
    //   this.otherCircle = this.allCircles.filter(ele => ele.enter !== true)
    // },
  },

  created() {
    console.warn('AllCircles.vue is created');
    eventBus.$on("refresh-circle-members-rootlogin", () => {
      // this.init();
    })
  },

  mounted() {
    // this.$store.commit("Posts/resetPosts")
    // this.init();
  },

  methods: {
    goToSSO() {
      window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${process.env.SSO_BASE_URL}/mycircles`
    },
    /**
     * Initialization
     */

    // async init() {
    //   this.isFetchingCircles = true;

    //   await CircleRepository.all("", "")
    //     .then(async res => {
    //       this.enteredCircles = res.data.data.my_circles;
    //       this.myCircles = this.authUser
    //         ? this.authUser.user.hasOwnProperty("verified_account")
    //           ? res.data.data.all_circles
    //           : res.data.data.my_circles
    //         : [];

    //       if (this.authUser) {
    //         if (this.authUser.user.hasOwnProperty("verified_account")) {
    //           this.allCircles = await res.data.data.all_circles;
    //         } else {
    //           this.allCircles = await this.circleDiff(
    //             res.data.data.all_circles
    //           );
    //         }
    //       } else {
    //         this.allCircles = await res.data.data.all_circles;
    //       }

    //       this.isFetchingCircles = false;
    //     })
    //     .catch(err => {});
    // },

    /**
     * Filter circles based on the condition that it's present in mycicles or not
     *
     * @param {Array} allCircles
     */

    // circleDiff(allCircles) {
    //   if (this.authUser) {
    //     const userCircles = this.enteredCircles || this.authUser.user.circles;
    //     allCircles.forEach(a => {
    //       const found = userCircles.some(b => b.id === a.id);
    //       if (found) {
    //         a["enter"] = true;
    //       }
    //     });

    //     return allCircles;
    //   }
    // },

    // async getStartedButton() {
    //   try {
    //     const head = document.querySelector(".resend-email-box")
    //     head && head.classList.remove("sticky_header")
    //   } catch (e) {
    //     console.log(e)
    //   }
    //   if (!this.authUser) {
    //     document.body.scrollTop = 0
    //     setTimeout(() => {
    //       this.$store.commit("SsoLogin/openModal")
    //     }, 800)
    //     // this.$refs.modal.open()
    //   } else if (this.authUser && this.authUser.user.hasOwnProperty("is_verified") && this.authUser.user.is_verified === false) {
    //     this.$router.push({ path: "/searchpage" })
    //     this.$refs.accVerify.showModal()
    //   } else if (this.authUser && this.authUser.user.hasOwnProperty("is_verified") && this.authUser.user.is_verified === true) {
    //     this.$router.push({ path: "/searchpage" })
    //   }
    // },

    /**
     * Go to diffeent circle page based on user selection
     *
     * @param {Object} circle
     * @param {Object} event
     */
    // goToCircle(circleInfo, event) {
    //   this.selectedCircle = circleInfo.condition_type;
    //   const target = event.target.id;

    //   CircleRepository.all("", circleInfo.id)
    //     .then(res => {
    //       let circle = res.data.data.all_circles[0];
    //       if (!this.authUser) {
    //         document.body.scrollTop = 0;

    //         setTimeout(() => {
    //           this.$refs.modal.open();
    //         }, 1000);
    //       } else if (
    //         this.authUser &&
    //         this.authUser.user.hasOwnProperty("verified_account") &&
    //         this.authUser.user.verified_account === false
    //       ) {
    //         this.$refs.accVerify.showModal();
    //       } else {
    //         this.$store.dispatch("Circle/diseaseTypes", { type: circle.id });
    //         this.$store.commit("Circle/setCurrentCircle", { data: circle });
    //         target === "enter"
    //           ? this.checkAndRoute(circle)
    //           : this.goToCircleDescription(circle); //if there is more than one role to enable to there is more role do a if condition here with the new api
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },

    // goToCircleDescription(data) {
    //   this.$store.dispatch("Circle/diseaseTypes", { type: data.id });
    //   this.$store.commit("Circle/setCurrentCircle", { data: data });

    //   this.$router.push({
    //     name: "CircleDescription",
    //     params: {
    //       circle: this.currentCircle.key_name
    //     }
    //   });
    // },

    // checkAndRoute(circle) {
    //   AppRepository.getHasMultiRole(this.currentCircle.id)
    //     .then(res => {
    //       if (!res.data.data.length) {
    //         let selectedRole;

    //         selectedRole = this.$store.state.User.user.user.multiRole.filter(
    //           r => r.circle_id === this.currentCircle.id
    //         )[0].role;

    //         const payload = {
    //           role: selectedRole,
    //           circle_id: this.currentCircle.id
    //         };

    //         AppRepository.postHasMultiRole(payload).then(res => {
    //           UserRepository.getSelfProfile(this.authUser.user, circle.id).then(
    //             res => {
    //               console.log("I AM CALLING");
    //               this.$store.state.User.user.user.display_name = res.data.data
    //                 .user_info.display_name
    //                 ? res.data.data.user_info.display_name.toLowerCase()
    //                 : "D";
    //               this.authUser.user.role = selectedRole;
    //               this.$router.push(
    //                 `/${this.currentCircle.key_name}/home/activity`
    //               );
    //             }
    //           );
    //         });
    //       }
    //       if (res.data.data.length === 1) {
    //         const payload = {
    //           role: res.data.data[0].role,
    //           circle_id: this.currentCircle.id
    //         };

    //         AppRepository.postHasMultiRole(payload).then(res => {
    //           UserRepository.getSelfProfile(this.authUser.user, circle.id).then(
    //             res => {
    //               console.log("I AM CALLING");
    //               this.authUser.user.display_name = res.data.data.user_info.display_name.toLowerCase();
    //               this.authUser.user.first_post =
    //                 res.data.data.user_info.first_post;
    //               this.authUser.user.role = payload.role;
    //               this.$router.push(
    //                 `/${this.currentCircle.key_name}/home/activity`
    //               );
    //             }
    //           );
    //         });
    //       }
    //       if (res.data.data.length > 1) {
    //         this.$router.push(`/${this.currentCircle.key_name}/select-profile`);
    //       }
    //     })
    //     .catch(err => {});
    // },

    // goToCrisisPage() {
    //   this.$router.push({
    //     name: "CrisisHelpline"
    //   });
    // },

    // goToRole(circle, event) {
    //   const target = event.target.id;
    //   if (target === "enter")
    //     this.$router.push(`/${circle.key_name}/select-profile`);
    // },

    // enterCircle(circle, event, bool) {
    //   event.target.id === "enter"
    //     ? this.checkAndRoute(circle, bool)
    //     : this.$router.push(`/${circle.key_name}/signup`).catch(err => {});
    // },

    handleSelectBox(num) {
      if (num === "3") {
        this.isHOA = true
      } else {
        this.isHOA = false
      }
      const x = document.querySelectorAll(".choose-role--box")
      const y = document.querySelectorAll(".choose-box--description")
      const roleLabel = document.querySelectorAll(".choose-role--box__big")
      for (let i = 0; i < x.length; i++) {
        if (x[i].classList.contains("selected")) {
          x[i].classList.remove("selected")
          y[i].classList.remove("show-class")
          y[i].classList.add("none-class")
          roleLabel[i].classList.remove("active-label")
        }
      }
      x[num].classList.add("selected")
      y[num].classList.add("show-class")
      y[num].classList.add("selected-box")
      roleLabel[num].classList.remove("active-label")
      y[num].classList.remove("none-class")
    },
  },
}
</script>

<style lang="scss" scoped>
.learn-more-section {
  margin-top: 85px;
}
.active-label {
  color: #ffffff !important;
}
.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}
.enter-button {
  // border: 1px solid #062b54 !important;
  background: #062b54;
  color: #ffffff !important;
}
.all-circle-card:not(:last-child) {
  margin-bottom: 50px;
}

.joined-circle {
  min-height: 0px !important;
}

.allcircles {
  position: relative;

  &-card {
    min-height: 200px;
    margin: auto;
    background-color: #ffffff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 8px;
    display: flex;
    padding: 20px;
    margin-bottom: 20px;

    @media screen and (max-width: 900px) {
      max-height: 450px;
      flex-direction: column;
      padding: 30px 0px;
    }

    &-left {
      display: flex;
      min-width: 720px;
      margin-right: 20px;
      @media screen and (max-width: 1200px) {
        margin-right: 0px;
        min-width: 490px;
        // margin-top: -65px;
      }
      @media screen and (max-width: 900px) {
        margin-right: 0px;
        min-width: fit-content;
        // margin-top: -65px;
      }
      &--top {
        display: flex;
        margin-bottom: 18px;
        margin-left: 16px;
        @media screen and (max-width: 900px) {
          display: flex;

          margin-bottom: 0px;
          align-items: center;
        }
      }
      &--color {
        &--img {
          height: 60px;
          width: 60px;
          display: flex;
          flex-shrink: 0;
          border-radius: 50%;
          background-color: #0dcbbb;

          // @media screen and (max-width: 900px) {
          //   position: absolute;
          //   transform: translate(50%, 50%);
          // }
        }
      }

      &--name {
        display: flex;
        flex-direction: column;
        padding-left: 16px;

        @media screen and (max-width: 900px) {
          display: flex;
        }

        &--type {
          font-weight: 700;
          font-size: 24px;
          margin-bottom: 18px;
          // max-height: 70px;
          // overflow: hidden;
        }

        &--ldescription {
          font-size: 16px;
          line-height: 30px;
          @media screen and (max-width: 1200px) {
            display: none;
          }
        }

        &--description {
          font-size: 16px;
          line-height: 19px;
          font-style: italic;
          font-weight: bold;
          margin-bottom: 16px;
          overflow: hidden;

          @media screen and (max-width: 1200px) {
            margin-bottom: 0px;
            display: none;
          }
        }
      }
    }

    &-center {
      min-width: 486px;
      max-width: 486px;
      font-size: 16px;
      line-height: 28px;

      @media screen and (max-width: 1200px) {
        overflow: hidden;
      }

      @media screen and (max-width: 900px) {
        display: none;
      }
    }

    &-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 35px;
      justify-content: center;

      @media screen and (max-width: 900px) {
        padding: 0px;
      }
      &--info {
        display: flex;
        font-weight: bold;

        @media screen and (max-width: 900px) {
          margin-top: 20px;

          width: 100%;
          // display: flex;
          justify-content: space-around;
        }

        &--box {
          padding: 14px 14px 16px 24px;
          background: rgba(6, 43, 84, 0.03);
          border-radius: 3px;
          width: 100px;
          height: 67px;

          @media screen and (max-width: 900px) {
            width: fit-content;
          }
        }

        &__text {
          font-size: 14px;
          line-height: 14px;
        }

        &__number {
          font-size: 18px;
          line-height: 18px;
          margin: 3px;
        }
      }

      .dovemed-button {
        // padding: 13px 84px;
        width: 100%;
        font-weight: bold;
        margin-top: 24px;

        @media screen and (max-width: 900px) {
          padding: 13px 84px;
          width: fit-content;
        }
      }
    }
  }
}
.title-text {
  font-size: 24px;
  font-weight: bold;
  line-height: 36px;
  padding-bottom: 24px;

  &--black {
    font-size: 32px;
    font-weight: bold;
    line-height: 36px;
    padding-bottom: 50px;
    color: #333333;
    text-align: center;
  }
}
.text-small {
  color: #ffffff;
  text-align: center;
  margin-top: 24px;
  font-size: 12px;
  line-height: 19px;

  &--black {
    padding-top: 80px;
    font-size: 10px;
    margin-bottom: 4px;
    letter-spacing: 2px;
    color: #333333;
    text-align: center;
    font-weight: bold;
  }
}

.choose-role {
  justify-content: space-evenly;
  padding-bottom: 20px;

  @media screen and (max-width: 1200px) {
    padding-bottom: 26px;
    overflow-y: scroll;
    justify-content: normal;
  }
  @media screen and (max-width: 900px) {
    padding-bottom: 26px;
    overflow-y: scroll;
    justify-content: normal;
  }
  @media screen and (max-width: 700px) {
    padding-bottom: 26px;
    overflow-y: scroll;
    justify-content: normal;
  }

  &--box {
    min-width: 216px;
    max-width: 216px;
    min-height: 128px;
    max-height: 128px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    &__medium {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .selected {
    background: #062b54 !important;
    color: #ffffff;
    text-align: left;

    position: relative;
    transition: all ease-in;
    box-sizing: border-box;
    animation: sample 0.41s ease-in-out;
    .choose-role--box {
      &__big,
      &__medium {
        color: #ffffff;
      }
    }
    .box-icon {
      padding: 8px 7px 8px 7px;
      text-align: center;
      background: #ffffff2e;
      color: #ffffff;
      border-radius: 8px;
      // min-width: 36px;
      // min-height: 36px;
      min-width: 40px;
      min-height: 40px;
    }
  }
  .selected:after {
    content: "";
    height: 0;
    width: 0;
    border-width: 20px 23px 19px 6px;
    border-style: solid;
    border-color: rgba(6, 43, 84, 0) rgba(6, 43, 84, 1) rgba(6, 43, 84, 0) rgba(6, 43, 84, 0);
    position: absolute;
    bottom: -30px;
    left: 40%;
    transform: rotate(270deg);
  }

  .box-icon {
    padding: 8px 7px 8px 7px;
    text-align: center;
    background: #5294f02a;
    color: #2a71d4;
    border-radius: 8px;
    // min-width: 36px;
    // min-height: 36px;
    min-width: 40px;
    min-height: 40px;
  }
  // .hospital-icon img{
  //   width: 22.5px;
  //   height: 20px;
  // }

  .white {
    color: #ffffff;
  }

  .box-icon:after {
    content: "";
    // color: #2a71d4;
  }
}

.role-label {
  color: #647490;
  font-size: 14px;
}

.role-label-md {
  color: #1e2945;
  font-size: 20px;
}

@keyframes sample {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.circle-phone {
  display: flex;
  align-items: center;

  height: 40px;
  width: 40px;
  color: white;
  border-radius: 50%;
  justify-content: center;
  font-size: 27px;
}

@keyframes selected-box {
  0% {
    opacity: 0;
    transform: translateX(80%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.selected-box {
  animation: selected-box 0.41s ease-in-out;
}

// .ant-carousel >>> .slick-slide p {
//   color: #fff;
// }
.ant-carousel .slick-dots {
  bottom: -12px;
}
.ant-carousel .slick-dots li button {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  background: #2a71d4 !important;
}

.crisis-info {
  position: relative;
  width: 100vw;
  left: calc(-50vw + 50%);
  background: #062b54;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  padding: 50px 210px;
  justify-content: space-between;
  @media screen and (max-width: 1200px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    max-width: fit-content;
    left: calc(-50vw + 54%);
  }
  @media screen and (max-width: 900px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    max-width: fit-content;
  }
  @media screen and (max-width: 700px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    max-width: fit-content;
  }
  &-top {
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 23px;
  }

  &-mid {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 41px;
  }
  &-bottom {
    .dovemed-button {
      background: #2a71d4;
      text-transform: uppercase;
      cursor: pointer;
      font-weight: bold;
      font-size: 16px;
      line-height: 18px;

      padding: 14px 50px;
    }
  }
}

.getstarted {
  position: relative;
  width: 100vw;
  left: calc(-50vw + 50%);
  background: #062b54;
  display: flex;
  // padding: 50px 210px;
  padding: 50px 80px;
  justify-content: space-between;
  @media screen and (max-width: 1200px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    // max-width: fit-content;
    // left: calc(-50vw + 54%);
  }
  @media screen and (max-width: 900px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    // max-width: fit-content;
  }
  @media screen and (max-width: 700px) {
    padding: 20px;
    display: flex;
    flex-direction: column;
    // max-width: fit-content;
  }
  &--left {
    max-width: 79%;
    color: #ffffff;
    @media screen and (max-width: 900px) {
      max-width: 100%;
    }

    &__big {
      font-size: 32px;
      font-weight: 600;
      padding-bottom: 20px;
    }

    &__medium {
      font-size: 18px;
      font-weight: 600;
      line-height: 36px;
    }
  }

  &--right {
    height: fit-content;
    margin-top: 30px;
    padding: 15px 0px;
    background: #2a71d4;
    color: #ffffff;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    max-width: fit-content;
    .button {
      width: 200px;
      text-align: center;
    }
  }
}

.centered-div {
  text-align: center;
  font-size: 16px;
  padding-bottom: 0px 30px 45px 30px;
  display: flex !important;
  flex-direction: column;
}

// .ant-carousel >>> .slick-slide p {
//   color: #fff;
// }
.ant-carousel .slick-dots li button {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  background: #2a71d4 !important;
}
.clearfix::after {
  content: "";
  clear: both;
  display: table;
}
.advertise-text-author-name {
  float: center;
}
.hw20 {
  height: 20px !important;
  width: 20px !important;
  background-size: contain;
}
.hw25 {
  height: 25px !important;
  width: 25px !important;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/App/circle/AllCircles.vue